import React, {useEffect, useState} from 'react';
import Modal from '../../../../../components-new/ui/Modal';
import {getCategories, getConversationInfo, saveConversationInfo,} from '../../../../../services/company/api';
import config from '../../../../../config';
import {addNotification as addNotificationAction} from '../../../../../services/notification/action';
import {connect} from 'react-redux';
import {generalModalStyles} from '../../../../../utils/General';
import Translate, {t} from "../../../../../components/Translate";
import Input from "../../../../../components-new/form/Input";
import SilverButton from "../../../../../components-new/buttons/SilverButton";
import BlueButton from "../../../../../components-new/buttons/BlueButton";
import DropdownSelect from "../../../../../components-new/form/DropdownSelect";
import Checkbox from "../../../../../components-new/form/Checkbox";
import Field from "../../../../../components-new/form/Field";
import NotebookPenIcon from "../../../../../assets/icons/NotebookPenIcon";
import './ChatActionModals.css';

const priorities = [
    {value: 'high', label: 'High', icon: '↑', color: 'var(--ds-danger-600)', id: 1},
    {value: 'medium', label: 'Medium', icon: '→', color: 'var(--ds-warning-500)', id: 2},
    {value: 'low', label: 'Low', icon: '↓', color: 'var(--ds-success-600)', id: 3},
];

const TicketModal = ({
                         isOpen,
                         cancelAction,
                         conversation,
                         user,
                         addNotification,
                         features,
                         company,
                     }) => {
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [subject, setSubject] = useState('');
    const [description, setDescription] = useState('');
    const [priority, setPriority] = useState('');
    const [isTicket, setIsTicket] = useState(false);
    const [assignee, setAssignee] = useState('');

    const users = ((company && company.members) || [])
        .filter(m => m.status === config.statusMap.enabled);

    const [categoryOptions, setCategoryOptions] = useState([]);

    useEffect(() => {
        if (isOpen && conversation) {
            (async () => {
                const conv = await getConversationInfo(conversation.id);
                const cats = await getCategories(conversation.companyId);

                setCategories(cats);

                const options = [
                    {label: t({text: 'withoutCategory', user}), value: ''}
                ];
                cats.map(c => {
                    options.push({label: c.name, value: c.id});
                })

                setCategoryOptions(options);

                setSelectedCategory(options.find(o => o.value == conv.categoryId) || options[0]);

                setSubject(conv.subject || '');
                setDescription(conv.description || '');
                setPriority(conv.priority || '');
                setIsTicket(conv.ticket || false);
                setAssignee(conv.assignedUser ? conv.assignedUser.platformId : '');
            })();
        }
    }, [isOpen, conversation, user]);

    const handleSave = () => {
        saveConversationInfo(
            selectedCategory.value,
            subject,
            description,
            priority,
            false, // inProcess not relevant here
            isTicket,
            conversation.id,
            assignee
        )
            .then(() =>
                addNotification(
                    'convInfoCreated/Updated',
                    config.notificationLevels.success
                )
            )
            .catch(() =>
                addNotification('somethingWentWrong', config.notificationLevels.error)
            );

        cancelAction();
    };

    const priorityOptions = [
        {
            label: t({text: 'priority', user}),
            value: '',
            disabled: true
        },
        ...priorities.map(p => ({
            label: `${p.icon} ${p.label}`,
            value: p.value,
            color: p.color
        }))
    ];

    const assigneeOptions = [
        {
            label: t({text: 'assignee', user}),
            value: '',
            disabled: true
        },
        ...users.map(usr => ({
            label: `${usr.firstName} ${usr.lastName}`,
            value: usr.id
        }))
    ];


    return (
        <Modal
            isOpen={isOpen}
            style={generalModalStyles.convHeaderModalStyles}
            onRequestClose={cancelAction}
            title={<Translate text="notes"/>}
            description={<Translate text="notesModalDescription"/>}
            headerIcon={<NotebookPenIcon width={20} height={20} stroke="var(--ds-fg-secondary)"/>}
            headerSeparator
            footerSeparator
            footer={<React.Fragment>
                <SilverButton type="button" width="auto" height="40px" onClick={cancelAction}>
                    <Translate text="close"/>
                </SilverButton>
                <BlueButton type="button" width="auto" height="40px" onClick={handleSave}>
                    <Translate text="save"/>
                </BlueButton>
            </React.Fragment>}
        >
            <div className="chat-action-modal__body">
                {features.includes(config.features.CATEGORIES) && (
                    <Field label="category">
                        <DropdownSelect
                            selectedValue={selectedCategory}
                            options={categoryOptions}
                            onChange={e => setSelectedCategory(e)}
                            styles={{width: '100%', height: '40px'}}
                        />
                    </Field>
                )}

                <Input label={<Translate text="subject"/>} value={subject} maxLength={150} type="text"
                       name="subject" style={{height: '40px'}} onChange={e => setSubject(e.target.value)}/>

                <Input label={<Translate text="description"/>} isTextarea style={{minHeight: '160px'}}
                       value={description} resize="none" maxLength={5000} name="description"
                       onChange={e => setDescription(e.target.value)}/>

                {features.includes(config.features.TICKETS) && (
                    <Checkbox
                        checked={!!isTicket}
                        handleChange={e => setIsTicket(e)}
                        label={<Translate text="isTicket"/>}
                    />
                )}

                {features.includes(config.features.TICKETS) && isTicket && (
                    <Field label="priority">
                        <DropdownSelect selectedValue={priorityOptions.find(o => o.value === priority)}
                                        options={priorityOptions} onChange={option => setPriority(option.value)}
                                        styles={{
                                            width: '100%',
                                            height: '40px',
                                            color: (priorityOptions.find(o => o.value === priority) || {}).color || 'black'
                                        }}
                                        direction={'top'}
                        >
                            {option => <span style={{color: option.color}}>{option.label}</span>}
                        </DropdownSelect>
                    </Field>
                )}

                {features.includes(config.features.TICKETS) && isTicket && (
                    <Field label="assignee">
                        <DropdownSelect selectedValue={assigneeOptions.find(o => o.value === (assignee || ''))}
                                        options={assigneeOptions} onChange={option => setAssignee(option.value)}
                                        styles={{width: '100%', height: '40px'}} direction={'top'}/>
                    </Field>
                )}
            </div>
        </Modal>
    );
};

const mapDispatchToProps = dispatch => ({
    addNotification: (message, level, config) => {
        dispatch(addNotificationAction(message, level, config));
    },
});

export default connect(null, mapDispatchToProps)(TicketModal);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/TicketModal.jsx